/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import getBuilderStateContentVariantData from '~/builder/utils/getBuilderStateContentVariantData';
import { ProductsV2Provider } from '~/gridv2/context/ProductsV2Provider';
import { GRID_TYPES, GridInputProvider } from '~/gridv2/hooks/useGridInputs';
import GridViewRenderer from '~/gridv2/views/GridViewRenderer';

/**
 * Notes: Support for sidenav has been removed for this grid version, per the
 * side nav refactor. It is now only supported for Constructor Grids.
 *
 * Note: not all builder props are used directly via the refactored grid. Some
 * props (e.g. `brand`, `maxItemCount`, `sortList`) are passed via the builderBlock
 * component options and consumed via the grid hooks. See `getBuilderCollectionContent()`
 * in `useProductsV2()` for more details.
 */
const BuilderProductsV2GridV2 = ({
  builderBlock,
  builderState,
  discoveryGuide: discoveryGuideProp,
  filters,
  fplGlobalCodes,
  gridAssetContainer,
  gridAssetContainerMobile,
  gridCTA,
  gridGender,
  gridStyleGuide,
  productSource,
  label,
}) => {
  // This is to prevent content shift between SSR and CSR hydration
  if (typeof window === 'undefined') {
    return null;
  }

  const pageData = getBuilderStateContentVariantData({
    builderStateContent: builderState?.content,
  });
  const gridSpotlights = pageData?.gridSpotlights?.value?.data;
  const discoveryGuide = discoveryGuideProp?.value?.data;

  return (
    <GridInputProvider
      value={{
        assetContainer: {
          gridAssetContainer,
          gridAssetContainerMobile,
        },
        builderBlock,
        builderState,
        builderModel: builderState?.state?.modelName,
        discoveryGuide,
        filters,
        fplGlobalCodes,
        gridCTA,
        gridGender,
        gridHeader: label,
        gridStyleGuide, // @deprecated in favor of using `discoveryGuide`
        gridSpotlights,
        gridType: GRID_TYPES.PRODUCTS_V2_GRID,
        productSource,
      }}
    >
      <ProductsV2Provider>
        <GridViewRenderer />
      </ProductsV2Provider>
    </GridInputProvider>
  );
};

BuilderProductsV2GridV2.propTypes = {
  builderBlock: PropTypes.object,
  builderState: PropTypes.shape({
    state: PropTypes.object,
    content: PropTypes.object,
  }),
  discoveryGuide: PropTypes.shape({
    value: PropTypes.shape({
      data: PropTypes.object,
    }),
  }),
  filters: PropTypes.arrayOf(PropTypes.shape({ filter: PropTypes.string })),
  fplGlobalCodes: PropTypes.arrayOf(PropTypes.string),
  gridAssetContainer: PropTypes.string,
  gridAssetContainerMobile: PropTypes.string,
  gridCTA: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  }),
  gridGender: PropTypes.string,
  gridStyleGuide: PropTypes.object,
  label: PropTypes.string,
  productSource: PropTypes.string,
};

export default BuilderProductsV2GridV2;
